import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';

import { IMG_EMPTY_MATCHING } from 'images';

const useStyles = makeStyles(() => ({
  emptyContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  emptyContainerImage: {
    width: 300,
  },
  emptyContainerTitle: {
    fontSize: 16,
    color: 'rgba(0, 0, 0, 0.6)',
    paddingTop: 35,
    letterSpacing: '0.15px',
    textAlign: 'center',
    paddingBottom: 50,
  },
}));

const DayWiseApplicationEmpty = ({ isEmpty = false }) => {
  const classes = useStyles();

  if (!isEmpty) {
    return null;
  }

  return (
    <div className={classes.emptyContainer}>
      <img
        className={classes.emptyContainerImage}
        src={IMG_EMPTY_MATCHING}
        alt={'Nothing to show.'}
      />
      <Typography className={classes.emptyContainerTitle}>
        No data for the selected period, Change the filters for data to be
        populated
      </Typography>
    </div>
  );
};

export default DayWiseApplicationEmpty;
